import { Helpers } from '../../helpers';
import { IForecastVertical } from '../../interfaces/iforecast-vertical';
import { Forecast } from '../forecast';
import { ForecastVerticalDetail } from '../forecast-vertical-detail';

export class ForecastVerticalBase {
  ForecastVerticalId: number;
  BusinessUnitId: number;
  Name: string | null;
  Description: string | null;
  IsApproved: string | null;
  Created: Date;
  Updated: Date;
  CreatedBy: string | null;
  UpdatedBy: string | null;
  ForecastId: number | null;

  ForecastVerticalDetails_ForecastVertical?: Array<ForecastVerticalDetail> | null;
  Forecast?: Forecast;

  constructor(item?: IForecastVertical) {
    if (item) {

      this.ForecastVerticalId = item.ForecastVerticalId;
      this.BusinessUnitId = item.BusinessUnitId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.IsApproved = item.IsApproved;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.UpdatedBy = item.UpdatedBy;
      this.ForecastId = item.ForecastId;

      this.ForecastVerticalDetails_ForecastVertical = Helpers.createClassArray(ForecastVerticalDetail, item.ForecastVerticalDetails_ForecastVertical);
      this.Forecast = new Forecast(item.Forecast);
    }
  }
}